export default function(element, cssTransitionClass, {delay, ratio}) {
    const flipAnimator = new FlipAnimator(element, cssTransitionClass, {delay, ratio});
    flipAnimator.animateFrom();
    return flipAnimator;
}

class FlipAnimator {
    constructor(element, cssTransitionClass, {delay, ratio}) {
        this.element = element;
        this.cssTransitionClass = cssTransitionClass;
        this.delay = delay;
        this.ratio = ratio;

        this.fromBounds = null;
        this.timers = [];
    }

    animateFrom() {
        this.fromBounds = this.element.getBoundingClientRect();
    }

    animateTo() {
        const {fromBounds} = this;
        const toBounds = this.element.getBoundingClientRect();

        const tx =
            (fromBounds.left + fromBounds.right) / 2 -
            (toBounds.left + toBounds.right) / 2;
        const ty =
            (fromBounds.top + fromBounds.bottom) / 2 -
            (toBounds.top + toBounds.bottom) / 2;
        const s = this.calculateScale(fromBounds, toBounds);

        this.element.style.transform = `translate(${tx}px, ${ty}px) scale(${s})`;
        this.addTimeout(() => {
            this.element.classList.add(this.cssTransitionClass);
        }, this.delay);
        this.addTimeout(() => {
            this.element.style.transform = 'none';
        }, this.delay);
    }

    calculateScale(fromBounds, toBounds) {
        if (!this.ratio) {
            return fromBounds.width / toBounds.width;
        }

        const fromRatioBounds = this.findRatioBounds(fromBounds);
        const toRatioBounds = this.findRatioBounds(toBounds);

        return fromRatioBounds.width / toRatioBounds.width;
    }

    findRatioBounds(bounds) {
        const width = Math.min(bounds.width, this.ratio * bounds.height);
        const height = Math.min(bounds.height, (1 / this.ratio) * bounds.width);

        return {width, height};
    }

    addTimeout(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
    }

    stop() {
        for (const timer of this.timers) {
            clearTimeout(timer);
        }
    }
}
